module.exports = __webpack_public_path__ + "img/hamochiLike.f2e319ef.png";